"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavContext = _interopRequireDefault(require("../../../../context/NavContext"));
var _NavItem = _interopRequireDefault(require("../NavItem"));
const NavItems = _ref => {
  let {
    isPrimaryNav = false,
    position,
    menuItems,
    ModalComp,
    openChangePasswordModal
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, menuItems.map((navItem, index) => {
    const key = position === 'left' ? navItem.text : navItem.icon;
    const navItemId = "".concat(position, "-").concat(key);
    return /*#__PURE__*/_react.default.createElement(_NavContext.default, {
      key: key
    }, /*#__PURE__*/_react.default.createElement(_NavItem.default, Object.assign({}, navItem, {
      isPrimaryNav: isPrimaryNav,
      menuItemId: navItemId,
      subMenuToLeft: position === 'right',
      noRightMargin: index === menuItems.length - 1,
      ModalComp: ModalComp,
      openChangePasswordModal: openChangePasswordModal
    })));
  }));
};
var _default = exports.default = NavItems;